import { useSiteMediaState } from "@/lib/site";

export const InstallVideo = ({ testId = "install-video", className = "" }) => {
  const { media, ready } = useSiteMediaState();
  const src = media["install-video"]?.url, poster = media["install-poster"]?.url;
  return (
    <figure className={`m-0 w-full max-w-[292px] md:w-auto md:max-w-none ${className}`}>
      {ready ? (
        <video key={src} data-testid={testId} src={src} poster={poster} controls playsInline preload="metadata"
          className="mx-auto block aspect-[9/16] w-full max-h-[520px] rounded-xl bg-[#EAE7E2] object-cover shadow-[0_24px_50px_-30px_rgba(8,8,8,0.5)] md:h-[520px] md:w-auto">
          Tu navegador no puede reproducir este video.
        </video>
      ) : <div className="mx-auto aspect-[9/16] w-full max-h-[520px] rounded-xl bg-[#EAE7E2] md:h-[520px] md:w-[292px]" />}
    </figure>
  );
};
